<template>
    <card-normal v-if="false" class="upgrade-now">
        <flex-container justify-content="center">
            <text-heading :color="'secondary'">
                Meer inzichten?
            </text-heading>

            <text-description horizontal-align="center">
                Upgrade nu naar onze meest geavanceerde systeem KeyVue. Hét ultieme lead platform met custom rapportages en diepgaande inzichten.
            </text-description>

            <button-block
                without-loading
                :color="'primary'"
                @completed="upgradeModal?.openOverlay(); $event.button.setState('content')"
            >
                Upgrade in 1 klik
            </button-block>
        </flex-container>

        <flex-container
            no-wrap
            justify-content="center"
            align-items="center"
        >
            <component
                :is="ImageTriangles1"
                style="height: 128px"
            />
            <img
                src="@/flow/flow/assets/logo.png"
                alt="KeyVue"
                style="width: 30%; margin-top: 1rem"
            />
            <component
                :is="ImageTriangles2"
                style="height: 128px"
            />
        </flex-container>
    </card-normal>

    <modal-dialog
        ref="upgradeModal"
        label="Upgraden"
        description="Upgrade nu naar KeyVue"
    >
        <div style="margin-bottom: 1rem">
            <text-decorator bold>
                Upgrade
            </text-decorator>
        </div>
        <text-heading>
            Upgrade nu naar KeyVue
        </text-heading>
        <text-description>
            Een slimme zet om over te stappen naar KeyVue, het meest geavanceerde
            systeem voor leadopvolging en rapportage in de makelaardij. Op onze
            website, keyvue.app, vind je alle informatie over de verschillende
            licenties en modules die KeyVue te bieden heeft. We maken het upgraden
            naar KeyVue super eenvoudig voor je. Met slechts één klik start het
            proces. Een van onze specialisten neemt dan jouw huidige
            Winck-instellingen onder de loep en stuurt je snel een advies over
            de KeyVue licentie die het beste bij jou past. Je krijgt de kans om
            alles door te spreken en de voordelen nog eens op een rijtje te zetten.
            Ben je daarna akkoord, dan is KeyVue binnen 24 uur actief voor jouw
            organisatie online.
        </text-description>

        <template #footer="{ bindings }">
            <dialog-footer>
                <flex-container align-items="center" justify-content="flex-end">
                    <button-text @click="bindings.overlay.closeOverlay()">
                        Sluiten
                    </button-text>
                    <button-block :color="'primary'" @click="() => {}">
                        Upgrade nu
                    </button-block>
                </flex-container>
            </dialog-footer>
        </template>
    </modal-dialog>
</template>

<script setup lang="ts">
    import {
        type ExposedOverlay,
        ButtonBlock,
        CardNormal,
        FlexContainer,
        TextDecorator,
        TextDescription,
        DialogFooter,
        TextHeading,
        ButtonText,
        ModalDialog,
    } from '@keyvue/one-ui';

    import { ref } from 'vue';
    import ImageTriangles1 from '@/flow/flow/assets/1.svg?component';
    import ImageTriangles2 from '@/flow/flow/assets/2.svg?component';

    const upgradeModal = ref<ExposedOverlay>();
</script>

<style scoped lang="scss">
.upgrade-now {
    :deep(.card-normal__content){
        padding: calc(size(sm) - 4px);
        border: 2px dotted color(brand-pink);
        border-radius: size(sm);
    }
}
</style>
